import { api } from 'api'
import { format } from 'date-fns'
import { stringify } from 'qs'

type GenerateVndlyTimesheetParams = {
  companyIds: number[]
  startDate: Date
  endDate: Date
}

export async function generateVndlyTimesheet(
  params: GenerateVndlyTimesheetParams,
  signal?: AbortSignal
) {
  const response = await api.get<string>('/company/vndly/timesheet/generate', {
    params: {
      companyIds: params.companyIds,
      startDate: format(params.startDate, 'yyyy-MM-dd'),
      endDate: format(params.endDate, 'yyyy-MM-dd'),
    },
    paramsSerializer: (queryParams) =>
      stringify(queryParams, { arrayFormat: 'repeat', indices: false }),
    responseType: 'text',
    signal,
  })

  return response.data
}
